import _Promise from 'babel-runtime/core-js/promise';
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import { removeAuth } from '@/utils/auth';
import qs from 'qs';
import { debounce } from 'throttle-debounce';
import router from '../router';

/**
 * 检查dom是否忽略
 * @param {*} e
 */
var clearCacheEnterLogin = debounce(500, function () {
  removeAuth().then(function () {
    location.reload(); // 为了重新实例化vue-router对象 避免bug
  }).catch(function () {
    location.reload();
  });
});

var errorMessage = debounce(500, function (message) {
  var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'error';

  Message({
    message: message,
    duration: 1500,
    type: type
  });
});

var confirmMessage = debounce(1000, function (message) {
  MessageBox.confirm(message, '提示', {
    confirmButtonText: '确定',
    showCancelButton: false,
    type: 'warning'
  }).then(function () {
    clearCacheEnterLogin();
  }).catch(function () {});
});

axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 创建axios实例
var hrefs = [];
if (window.location.href.indexOf('index.html') != -1) {
  hrefs = window.location.href.split('index.html');
} else {
  hrefs = window.location.href.split('#');
}
var baseURL = hrefs.length > 0 ? hrefs[0] : window.location.href;
// baseURL + 'index.php/' 默认请求地址
// process.env.BASE_API 自定义请求地址

window.BASE_URL = process.env.NODE_ENV === 'production' ? baseURL + 'index.php/' : process.env.BASE_API;

var service = axios.create({
  baseURL: window.BASE_URL, // api 的 base_url
  timeout: 600000 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(function (config) {
  var flag = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('application/json') !== -1;
  if (!flag) {
    var mult = config.headers['Content-Type'] && config.headers['Content-Type'].indexOf('multipart/form-data') !== -1;
    if (mult) {
      config.data = config.data;
    } else {
      config.data = qs.stringify(config.data);
    }
  } else {
    if (config.data === undefined || config.data === null) {
      // 不传参的情况下 json类型的提交数据，校准为 空对象
      config.data = {};
    }
  }
  return config;
}, function (error) {
  // Do something with request error
  return _Promise.reject(error);
});

// response 拦截器
service.interceptors.response.use(function (response) {
  /**
   * code为非20000是抛错 可结合自己业务进行修改
   */
  var res = response.data;
  if (response.status === 200 && response.config.responseType === 'blob') {
    // 文件类型特殊处理
    if (response.headers['content-disposition'] || response.headers['content-type'] && response.headers['content-type'].indexOf('application/pdf') != -1) {
      return response;
    } else {
      var resultBlob = new Blob([response.data], { type: 'application/json' });
      var fr = new FileReader();
      fr.onload = function () {
        var result = JSON.parse(this.result);
        if (result.msg) {
          errorMessage(result.msg, result.code == 1 ? 'success' : 'error');
        }
      };
      fr.readAsText(resultBlob);
    }
  } else if (res.code !== 200) {
    // 302	登录已失效
    if (res.code === 302) {
      if (res.data.extra === 1) {
        confirmMessage('\u60A8\u7684\u8D26\u53F7' + res.data.extraTime + '\u5728\u522B\u5904\u767B\u5F55\u3002\u5982\u975E\u672C\u4EBA\u64CD\u4F5C\uFF0C\u5219\u5BC6\u7801\u53EF\u80FD\u5DF2\u6CC4\u6F0F\uFF0C\u5EFA\u8BAE\u4FEE\u6539\u5BC6\u7801');
      } else {
        clearCacheEnterLogin();
      }
    } else if (res.code === 1005) {
      router.push('/welcome');
    } else {
      if (res.error) {
        errorMessage(res.error);
      }
    }
    return _Promise.reject(res);
  } else {
    return res;
  }
}, function (error) {
  if (error.response) {
    var response = error.response;
    if (response.status == 500) {
      errorMessage('网络错误，请检查您的网络');
    } else if (response.data && response.data.msg) {
      errorMessage(response.data.msg);
    }
  }
  return _Promise.reject(error);
});

export default service;